// `new DOMParser()` at module scope made this module — and therefore every
// module that transitively imports it, which is most of the editor's text and
// SVG path — impossible to import outside a browser. Constructing it on first
// use instead keeps the import side-effect-free without changing any call site:
// `domParser.parseFromString(...)` behaves exactly as before.
//
// A DOMParser holds no state between parses, so one lazily-created instance is
// equivalent to the eager one it replaces.
let instance = null;

const getParser = () => {
  if (!instance) instance = new DOMParser();
  return instance;
};

export const domParser = {
  parseFromString: (...args) => getParser().parseFromString(...args)
};
